/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Component/TestPlansHubRefreshLeftView" />
import * as React from "react";
import { IVssComponentProperties, VssComponent, RegionComponent } from "VSS/Platform/Layout";
import { SuiteTreeConnectedView } from "./SuiteTreeConnectedView";

export class TestPlansHubRefreshLeftView extends VssComponent<IVssComponentProperties> {
    constructor(props: IVssComponentProperties) {
        super(props);
    }

    render(): JSX.Element {
        return (
            <div className="testplans-hub-left-view v-scroll-auto custom-scrollbar">
                <RegionComponent className="testplans-segment" componentRegion="testplans-segment-region" />
                <SuiteTreeConnectedView />
            </div>
        );
    }
}
